import { useState } from 'react';
import useSound from 'use-sound';
import correctAnswerBling from '../../sounds/correctAnswerBling.wav'
// import wrongAnswerBuzz from '../../sounds/wrongAnswerBuzz.wav'
import wrongAnswerBuzz from '../../sounds/fail.mp3'
import { data } from './data/data_03_sauvat_sopivat.js'
import kuva from './images/peukku_350x430.png'

const SauvatSopivat = ({ visibilityHandler, soundsOn }) => {


    // Vastausvaihtoehtojen ääniefektit
    const [playCorrectAnswer] = useSound(correctAnswerBling);
    const [playWrongAnswer] = useSound(wrongAnswerBuzz);


    function Jatka() {


        visibilityHandler("kävelytekniikkaan - wtw")

    }


    return (

        <div className='sceneContainer'>

            <div id='image' className='kuvaBox'>


                {/* <img src={kuva} alt="kuva" style={{ width: '280px' }} /> */}
                <img src={kuva} alt="kuva" />


            </div>

            <div id='question'>
                <h5>{(data.kysymysteksti != null && data.kysymysteksti != "") ? data.kysymysteksti : null}</h5>
            </div>

            <div id='actions'>
                <button onClick={() => Jatka()}>Jatka</button>


            </div>
        </div>
    )

}

export default SauvatSopivat